import { normalize, denormalize, schema as normalizrSchemas } from 'normalizr'

export const entitiesSelector = state => state.entities

export const createEntitySelector = schema => createSelector(entitiesSelector, entities => entities[schema.key] || {})

export const denormalizedEntitySelector = schema =>
    createSelector(entitiesSelector, createEntitySelector(schema), (entities, entity) =>
        denormalize(entity, new normalizrSchemas.Values(schema), entities)
    )

export const createDenormalizedSelector = (inputOrSelector, schema) =>
    typeof inputOrSelector === 'function'
        ? createSelector(inputOrSelector, entitiesSelector, (input, entities) => {
              try {
                  return denormalize(input, schema, entities)
              } catch (e) {
                  return null
              }
          })
        : createSelector(entitiesSelector, entities => denormalize(inputOrSelector, schema, entities))

export const createNormalizedSelector = (inputOrSelector, schema) =>
    typeof inputOrSelector === 'function'
        ? createSelector(inputOrSelector, input => normalize(input, schema).result)
        : normalize(inputOrSelector, schema).result
